import { RootState } from '../../../Store/index';

export const selectOrganization = (state: RootState) => state.OrganizationReducer.organizationList;
export const selectCurrentOrganization = (state: RootState) => state.OrganizationReducer.currentOrganization;
export const selectIsModalOpen = (state: RootState) => state.OrganizationReducer.isModalOpen;